import type { FirestoreDataConverter } from 'firebase/firestore'
import { fromFirestore, toFirestore } from '~/firestore/converters/converter'
import type { SimulatorPermission, SimulatorPermissionDocument } from '~/types/simulator/simulator'

export const simulatorPermissionsConverter: FirestoreDataConverter<
    SimulatorPermission,
    SimulatorPermissionDocument
> = {
    fromFirestore,
    toFirestore,
}
